import { render, staticRenderFns } from "./SelectPlan.vue?vue&type=template&id=390773bc&scoped=true&"
import script from "./SelectPlan.vue?vue&type=script&lang=js&"
export * from "./SelectPlan.vue?vue&type=script&lang=js&"
import style0 from "./SelectPlan.vue?vue&type=style&index=0&id=390773bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390773bc",
  null
  
)

export default component.exports